(function () {
  /*
   * Modulo do componenet agenda-list-item (avisosList)
   */
  angular
    .module('agenda')
    .controller('AgendaListItemComponentController', [
      '$log',
      '$scope',
	  '$state',
	  'SessionData',
      AgendaListItemComponentController]);

  	function AgendaListItemComponentController($log, $scope, $state, SessionData) {
		var ctrl = this;

		//$log.debug('[AgendaListItemComponentController]\t$scope=', $scope, 'ctrl=', ctrl);
		ctrl.event.className = typeof(ctrl.event.className) == 'object' ? ctrl.event.className.join(' ') : ctrl.event.className;

		// Quando ctrl.event.end e ctrl.event.start forem numéricos, será utilizada a conversão para hora local
		// evitando assim que a hora seja inválida (diferente da hora local GTM-3:00)
		var endData = Number.isInteger(ctrl.event.end) ? moment.utc(ctrl.event.end).local() : moment.utc(ctrl.event.end);
		var startData = Number.isInteger(ctrl.event.start) ? moment.utc(ctrl.event.start).local() : moment.utc(ctrl.event.start);
		
		let dayMask = 'DD/MM/YYYY';
		let hourMask = 'HH:mm';
		let formatMask = dayMask + ' - ' + hourMask;
		
		
		ctrl.dataHora = moment(startData).format(ctrl.event.allDay ? dayMask : formatMask);
		
		if (endData.isValid() || !ctrl.event.allDay) {
			var horaEvento = moment(endData).format(endData.isSame(startData, 'day') ? hourMask : formatMask);
			ctrl.dataHora += (horaEvento == "00:00" )|| (moment(startData).format('HH:mm') == moment(endData).format('HH:mm')) ? "" : ' - ' + horaEvento;
		}     

		ctrl.dataHora += ctrl.event.allDay ? ' ' : '';

		ctrl.redirecinarMateriaisDisciplina = function redirecinarMateriaisDisciplina(){
			
			$state.go('home.disciplinas-publicacoes', 
				{
					'disciplina': ctrl.event.disciplinaObject
				}
			)
		
		}


      	$log.debug('[AgendaListItemComponentController]\tctrl=', ctrl);
   	}
})();
